<template>
  <div :class="{
    focused: isFocused,
    empty: !value,
    'is-error': error
  }">
    <input
      type="search"
      ref="search"
      :value="value"
      :disabled="disabled"
      @focus="onFocus"
      @blur="onBlur"
      @keydown.up="typeAheadUp"
      @keydown.down="typeAheadDown"
      @keyup.enter="typeAheadSelect"
      @input="changeSearchValue">

    <label v-if="label">{{ appliedLabel }}</label>

    <ul
      v-show="isLookupOpen"
      class="v-dropdown card"
      ref="dropdownMenu">
      <li
        v-for="(option, index) in options"
        :key="index"
        class="card"
        :class="{
          highlight: index === typeAheadPointer,
          separator: option.separator,
          paddedLarge: option.level
        }"
        @mousedown.prevent="select(option)">
        <span>{{ option[optionLabel] }}</span>
        <span class="search-subtitle">
          {{ option.sector }}, {{ option.baseCountry }}
        </span>
      </li>
    </ul>
    <span v-if="error" class="error">{{ error }}</span>
    <span v-if="required && !value" class="error">{{ requiredMessage }}</span>
  </div>
</template>

<script>
var pointerScroll = require('../mixins/scroll.js')
var typeAheadPointer = require('../mixins/typeahead.js')
var clickAway = require('vue-clickaway').mixin

module.exports = {
  name: 'a-input-autocomplete',
  mixins: [pointerScroll, typeAheadPointer, clickAway],
  props: {
    value: {
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    optionKey: {
      type: String,
      default: 'value',
    },
    optionLabel: {
      type: String,
      default: 'text',
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    requiredLabel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLookupOpen: false,
      isFocused: false,
    }
  },
  computed: {
    requiredMessage() {
      return `${this.label} is required`
    },
    appliedLabel() {
      let label = this.label
      if (this.requiredLabel) {
        label += ' *'
      }
      return label
    },
    // filtered alias required by typeAhead mixin
    filtered() {
      return this.options
    },
  },
  methods: {
    select(option) {
      this.$emit('input', option)
      this.isLookupOpen = false
    },
    changeSearchValue(e) {
      this.isLookupOpen = true
      this.$emit('input', e.target.value)
    },
    focus() {
      this.$refs.search.focus()
    },
    onFocus() {
      this.isLookupOpen = true
      this.isFocused = true
    },
    onBlur() {
      this.isLookupOpen = false
      this.isFocused = false
    },
    onEnter() {
      this.$emit('onEnter')
    },
  },
}
</script>

<style scoped>
div {
  display: inline-block;
  position: relative;
}
div::after {
  background-color: #95a1aa;
  content: '';
  position: absolute;
  top: 41px;
  left: 0;
  width: 100%;
  height: 1px;
  transform-origin: center bottom;
  transition: background-color 180ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 180ms cubic-bezier(0.4, 0, 0.2, 1);
}
div.is-error::after {
  background-color: red;
}
div.focused::after {
  background-color: #0381ff;
  transform: translateY(100%) scaleY(2);
}
input {
  font-size: 14px;
  line-height: 1;
  outline: none;
  padding: 16px 0 8px;
  width: 100%;
}
label {
  color: #95a1aa;
  cursor: text;
  font-size: 13px;
  font-weight: 400;
  line-height: 1;
  pointer-events: none;
  position: absolute;
  top: 19px;
  left: 0;
  transform-origin: left top;
  transition: color 180ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 180ms cubic-bezier(0.4, 0, 0.2, 1);
}
.focused > label {
  color: #0381ff;
  transform: translateY(-146%) scale(0.92, 0.92);
}
:not(.empty):not(.focused) > label {
  color: #95a1aa;
  transform: translateY(-146%) scale(0.92, 0.92);
}
button {
  border: none;
  box-shadow: none;
}
div a {
  cursor: pointer;
}
.v-dropdown svg {
  fill: rgba(0, 0, 0, 0.87);
}
input[type='search'] {
  border: none;
  margin: 0;
}
.v-dropdown {
  background-color: #fff;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  list-style: none;
  margin: 0;
  padding: 0;
  position: absolute;
  top: calc(100% + 1px);
  z-index: 1;
}
.v-dropdown li {
  cursor: pointer;
  padding: 0 28px 0px 8px;
  position: relative;
  white-space: nowrap;
}
.v-dropdown .highlight {
  background-color: #e1e1e1;
}
.v-dropdown .separator {
  border-top: 1px solid #e1e1e1;
}
.v-dropdown .paddedLarge {
  padding-right: 10em;
}
.v-dropdown li.card {
  padding: 1rem;
  box-shadow: none;
}
.v-dropdown li.card:first-child {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}
span.search-subtitle {
  display: block;
}
span.block {
  display: block;
}
.error {
  color: red;
  font-size: 12px;
  background: transparent !important;
}
</style>
